import React, {
    useState,
    useEffect,
    useContext,
    Fragment,
    useReducer,
} from 'react';
import Traductor from '../Traductor';
import Select from '../bronson/Select';
import { VehiclesContext } from '../../contexts/VehiclesContext';
import { formatPrice } from '../../js/components/shared/vehicleFunctions';
import SellService from '../../services/SellService';
import VehicleService from '../../services/VehicleService';
import ParseService from '../../services/ParseService';
import { withCookies } from 'react-cookie';
import Globals from '../../Globals';
import Loading from '../bronson/Loading';
import { UserContext } from '../../contexts/UserContext';
import { delegate } from 'tippy.js';
import '../../css/components/dealerReceptor/modalRejectVehicle.css';
import UserRejectIcon from '../../images/icons/user-reject-icon.png';
import errorTruckSvg from '../../images/icons//error-truck.svg';

function ModalSellVWRVehicle({ closeModal, cookies }) {
    const t = new Traductor();
    const { selectedVehicle } = useContext(VehiclesContext);
    const [loading, setLoading] = useState(false);
    const [entendido, setEntendido] = useState(false);
    const [errorRequest, setErrorRequest] = useState(false);
    const [errorRequestMessage, setErrorRequestMessage] = useState(null);
    const [sended, setSended] = useState(false);
    const { user } = useContext(UserContext);

    useEffect(() => {
        if (!selectedVehicle) closeModal();
    }, []);

    const closeThisModal = () => {
        if (sended) closeModal('Delete');
        else closeModal();
    };

    const printTitle = () => {
        if (sended) {
            return (
                <Fragment>
                    <img src={UserRejectIcon} style={{ width: '200px' }}></img>
                    <h1
                        className="c-modal__title u-mt-xlarge"
                        id="modal-reject-vehicle-title"
                    >
                        {' '}
                        {t.getTraduction('ModalRejectVehicle_title_rejected')}
                    </h1>
                </Fragment>
            );
        } else if (errorRequestMessage != null) {
            return (
                <Fragment>
                    <img src={errorTruckSvg} style={{ width: '200px' }}></img>
                    <h1
                        className="c-modal__title u-mt-xlarge"
                        id="modal-negotiate-vehicle-title"
                    >
                        {t.getTraduction('Oops')}
                    </h1>
                </Fragment>
            );
        } else {
            return (
                <Fragment>
                    <h1
                        className="c-modal__title"
                        id="modal-reject-vehicle-title"
                    >
                        {' '}
                        {t.getTraduction('SellVWR')}
                        {printHelpRegimeInfo()}
                    </h1>
                </Fragment>
            );
        }
    };

    const printInfoContainer = () => {
        if (sended) {
            return (
                <div
                    className="c-modal__content u-pl u-pr u-pb-large u-pb-none@s"
                    role="document"
                >
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1 u-text-center">
                            <p>
                                {t.getTraduction(
                                    'ModalSellVWRVehicle_body_rejected'
                                )}
                            </p>
                        </div>
                    </div>
                </div>
            );
        } else if (errorRequestMessage != null) {
            return (
                <div
                    className="c-modal__content u-pl u-pr u-pb-large u-pb-none@s"
                    role="document"
                >
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1 u-text-center">
                            <p>{errorRequestMessage}</p>
                        </div>
                    </div>
                </div>
            );
        } else {
            let message = null;
            let reason = null;

            message =
                    t.getTraduction('ModalSellVWRVehicle_body_1')
            
            return (
                <div
                    className="c-modal__content u-mt u-pt@xl u-pt@l u-pt-none@s u-pb-large u-pb-none@s"
                    role="document"
                >
                     <div className="o-layout">
                        <div className="o-layout__item u-1/1">
                            {selectedVehicle.ImporteIncentivoRecompraAC && selectedVehicle.ImporteIncentivoRecompraAC > 1 ? (
                                <p className="u-bg-pale u-text-center u-p u-mb-none u-text-success">
                                    {t.getTraduction('ModalSellVWRVehicle_incentive_prefix')}
                                    <strong>{new Intl.NumberFormat('ca', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(selectedVehicle.ImporteIncentivoRecompraAC)}</strong>
                                    {' '}<small style={{ fontSize: '0.8em' }}>(iva incluido)</small>
                                </p>
                            ) : null}
                            <p className="u-bg-pale u-text-center u-p u-mb-none">
                                {t.getTraduction('ModalSellVWRVehicle_body_2')}
                            </p> 
                            <p className="u-bg-pale u-text-center u-p u-mb-none">
                            <label className="c-checkbox">
                            <input
                                id="Entendido"
                                className="c-checkbox__input"
                                type="checkbox"
                                name="Hola"
                                onChange={e =>
                                    marcarEntendido(
                                        e
                                    )
                                }
                            ></input>
                            <span className="c-checkbox__label ">
                               Entendido
                            </span>
                        </label>
                        </p>                     
                        </div>
                    </div>
                    <br></br>
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1">
                            <p className="u-bg-pale u-text-center u-p u-mb-none">
                                {message}
                            </p>
                        </div>
                    </div>
                   
                </div>
            );
        }
    };

    const printFooterButtons = () => {
        let content = null;
        if (sended || errorRequestMessage != null) {
            content = (
                <div className="c-modal__actions__item">
                    <button
                        className="c-btn c-btn--secondary js-modal-close"
                        disabled={loading ? true : false}
                        aria-label="Cerrar"
                        onClick={() => closeThisModal()}
                    >
                        <span className="c-btn__text">
                            {t.getTraduction('Close')}
                        </span>
                    </button>
                </div>
            );
        } else {
            content = (
                <Fragment>

                    <div className="c-modal__actions__item">
                        <button
                            className="c-btn js-modal-close js-modal-autofocus"
                            disabled={entendido ? false : true}
                            aria-label="REBU"
                            onClick={validateREBU}
                        >
                            <span className="c-btn__text">
                                {t.getTraduction('REBU')}
                            </span>
                        </button>
                    </div>
                    <div className="c-modal__actions__item">
                        <button
                            className="c-btn js-modal-close js-modal-autofocus"
                            disabled={entendido ? false : true}
                            aria-label="Regimen General"
                            onClick={validateREG}                        >
                            <span className="c-btn__text">
                                {t.getTraduction('REG')}
                            </span>
                        </button>
                    </div>

                    <div className="c-modal__actions__item">
                        <button
                            className="c-btn c-btn--secondary js-modal-close"
                            disabled={loading ? true : false}
                            aria-label="Volver atrás"
                            onClick={() => closeModal('Prev')}
                        >
                            <span className="c-btn__text">
                                {t.getTraduction('Back')}
                            </span>
                        </button>
                    </div>
                </Fragment>
            );
        }
        if (content == null) return null;
        return (
            <div className="c-modal__footer">
                {errorRequest ? (
                    <p className="c-error-message u-text-center u-mb">
                        {t.getTraduction('RequestErrorMessage')}
                    </p>
                ) : null}
                <div className="c-modal__actions">{content}</div>
            </div>
        );
    };

    const printHelpRegimeInfo = () => {
        delegate('#root', {
            target: '[data-tippy-content]',
            allowHTML: true,
            theme: 'light',
        });
        var help="<ul style='font-size:13px'><li>"+t.getTraduction('ModalSellVWRVehicleHelp_body_1')+"</li><li>"+t.getTraduction('ModalSellVWRVehicleHelp_body_2')+"</li><li>"+t.getTraduction('ModalSellVWRVehicleHelp_body_3')+"</li></ul>";
        return (
            <Fragment>
                <button
                    type="button"
                    style={{ marginLeft: '10px' }}
                    className="c-icon c-info-icon js-tooltip c-icon--[semantic-info] c-info-icon-tooltip"
                    data-tippy-content={help}
                    data-tippy-placement="right"
                    tabIndex="-1"
                ></button>
            </Fragment>
        );
    };

    const validateREBU = () => {
        closeModal('SellAutoCreditREBU');
    };
    const validateREG = () => {
        closeModal('SellAutoCreditREG');
    };

    const marcarEntendido = (e) => {
        setEntendido(!entendido);
    };

    return (
        <Fragment>
            <div
                className="c-modal"
                aria-hidden="false"
                id="modal-reject-vehicle"
            >
                <div
                    className="c-modal__overlay  js-modal-close"
                    tabIndex="-1"
                ></div>
                <div
                    className="c-modal__wrapper"
                    role="dialog"
                    aria-labelledby="modal-reject-vehicle-title"
                >
                    <header className="c-modal__header">
                        <button
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Cerrar modal."
                            onClick={closeThisModal}
                        ></button>
                        <div className="c-modal__title__wrapper">
                            {printTitle()}
                        </div>
                    </header>
                    {printInfoContainer()}
                    {printFooterButtons()}
                    
                </div>                
            </div>
            <Loading ariaBusy={loading}></Loading>
        </Fragment>
    );
}

export default withCookies(ModalSellVWRVehicle);
